import { cloneDeep } from 'lodash'
import { OrderbookDataItem } from '../../store/orderbook/types'
import { isZero } from '../number'

export function insertAndMaintainOrder(
  localArray: OrderbookDataItem[],
  incrementalArray: OrderbookDataItem[],
  order: 'asc' | 'desc' = 'asc',
): OrderbookDataItem[] {
  const result = cloneDeep(localArray)
  incrementalArray.forEach((inc) => {
    const index = result.findIndex(({ price }) => price === inc.price)
    if (isZero(inc.amount)) {
      if (index !== -1) result.splice(index, 1)
    } else {
      if (index === -1) {
        let low = 0,
          high = result.length
        while (low < high) {
          const mid = Math.floor((low + high) / 2)
          if (
            order === 'asc'
              ? Number(result[mid].price) < Number(inc.price)
              : Number(result[mid].price) > Number(inc.price)
          ) {
            low = mid + 1
          } else {
            high = mid
          }
        }
        result.splice(low, 0, inc)
      } else {
        result[index] = inc
      }
    }
  })

  return result
}
